import { useState, useEffect } from 'react';
import { BuyerSignupPage } from './auth/BuyerSignupPage';
import { DesktopBuyerSignupPage } from './desktop/DesktopBuyerSignupPage';

export function ResponsiveBuyerSignupPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <BuyerSignupPage /> : <DesktopBuyerSignupPage />;
}